module.exports = __webpack_public_path__ + "img/detailBg.1d0d4152.png";